export default {
  USERS_LIST: "Liste des utilisateurs",
  ADD_USER: "Ajouter un utilisateur",
  USER_ADDED: "Utilisateur ajouté",
  IS_STAFF: "Admin",
  ALL_IS_STAFF: "Tous types",
  AUTHORIZATIONS: "Autorisations",
  EDIT_USER: "Modifier l'utilisateur",
  USER_UPDATED: "Utilisateur modifié",
  DELETE_THIS_USER: "Supprimer cet utilisateur ?",
  USER_DELETED: "Utilisateur supprimé",
  ACTIVE: "Actif",
  ACTIVATE: "Activer",
  DEACTIVATE: "Désactiver",
  USER_ACTIVATED: "Utilisateur Activé",
  USER_DEACTIVATED: "Utilisateur Désactivé",
  RESTRICT_TO_LOCATIONS: "Restreindre aux emplacements",
  RESTRICT_TO_SERVICE_CENTERS: "Restreindre aux centres de service",
  RESTRICT_TO_ESTABLISHMENTS: "Restreindre aux établissements",
  RESTRICT_TO_CAFETERIAS: "Restreindre aux cafétérias",
  PASSWORD_COMPLEXITY:
    "Le mot de passe doit contenir: des chiffres, des lettres, des majuscules, des minuscules, et faire au moins 8 caractères.",
  TWO_FACTOR_AUTHENTICATION: "Authentification à deux facteurs (2FA)",
  ENABLED: "Activée",
  DISABLED: "Désactivée",
  ENABLE_2FA: "Activer 2FA",
  DISABLE_2FA: "Désactiver 2FA",
  TWO_FA_ENABLED_AT: "2FA activée le",
  TWO_FA_DISABLED_AT: "2FA désactivée le",
  CONFIRM_ENABLE_2FA_TITLE: "Activer l'authentification à deux facteurs ?",
  CONFIRM_ENABLE_2FA_TEXT: "Vous devrez saisir un code de vérification envoyé à votre email à chaque connexion.",
  CONFIRM_DISABLE_2FA_TITLE: "Désactiver l'authentification à deux facteurs ?",
  CONFIRM_DISABLE_2FA_TEXT: "Votre compte sera moins sécurisé sans l'authentification à deux facteurs.",
  TWO_FA_ENABLED_SUCCESS: "L'authentification à deux facteurs a été activée avec succès.",
  TWO_FA_ENABLED_SUCCESS_LOGOUT: "L'authentification à deux facteurs a été activée avec succès. Vous allez être déconnecté et devrez vérifier avec un code lors de votre prochaine connexion.",
  TWO_FA_DISABLED_SUCCESS: "L'authentification à deux facteurs a été désactivée avec succès.",
};
